import React from "react";
import MealsSummary from "./MealsSumary";
import AvailableSummary from "./AvailableMeals";

function Meals() {
  return (
    <>
      <MealsSummary />
      <AvailableSummary />
    </>
  );
}

export default Meals;
